import { render } from "./PasswordResetAsk.vue?vue&type=template&id=a52381f2&ts=true"
import script from "./PasswordResetAsk.vue?vue&type=script&lang=ts"
export * from "./PasswordResetAsk.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__